module.exports = __webpack_public_path__ + "static/media/x.0bff6bac.svg";